export enum deviceFiltering
{
    all = 0,
    onlyMyPrinters = 1,
    sharedWithMe = 2
}